import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import React, { Dispatch, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { SwSelectMonth } from '../SwSelectMonth';

interface Props {
  head: string;
  open: boolean;
  onDownload: (month: any) => void;
  onClose: () => void;
}

export const SwDownloadDialog: React.FC<Props> = ({
  head,
  open,
  onDownload,
  onClose,
}) => {
  const [targetMonth, setTargetMonth] = useState<any>();

  const onWork = () => {
    onDownload(targetMonth);
  };

  return (
    <Dialog
      open={open}
      fullScreen
      sx={{
        '& .MuiDialog-paper': {
          height: '30vh',
          width: '40vh',
        },
      }}
    >
      <DialogTitle>
        <Box className='flex_between'>
          <span>{head}</span>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider sx={{ m: 0, p: 0 }} />
      <DialogContent>
        <Typography className='title'>다운로드할 월을 선택해주세요</Typography>
        <Box sx={{ mt: '2rem' }}>
          <SwSelectMonth
            onChangeMonth={item => {
              setTargetMonth(item);
            }}
            showSelectDay={false}
          />
        </Box>
      </DialogContent>
      <Divider sx={{ p: 0, m: 0 }} />
      <DialogActions>
        <Button color='info' fullWidth size='small' onClick={onClose}>
          취소
        </Button>
        <Button color='primary' fullWidth size='small' onClick={onWork}>
          다운로드
        </Button>
      </DialogActions>
    </Dialog>
  );
};
